<template>
  <div>
    <template v-if="isPresent(currentUser) && !isPresent(planSaleOptions)">
      <Alert type="warning">
        <template #title>Vous n'avez aucun contrat actif.</template>
      </Alert>
    </template>
    <template v-else>
      <h1 class="my-5 text-4xl font-extrabold tracking-tight text-gray-900">
        {{ $t("File a claim") }}
      </h1>
      <p class="mt-5">Un pépin est arrivé à votre produit ? Compléter le formulaire de déclaration de sinistre.</p>
      <FormField
        v-if="!isPresent(planSaleOptions)"
        id="planSaleFriendlyId"
        class="mt-5"
        v-model="planSaleFriendlyId"
        label="Numéro de contrat"
        name="planSaleFriendlyId"
        required
      />
      <Selector
        v-else
        id="planSaleFriendlyId"
        label="Numéro de contrat"
        name="planSaleFriendlyId"
        v-model="planSaleFriendlyId"
        :options="planSaleOptions"
        required
      />

      <FormField id="email" class="mt-5" v-model="email" label="Adresse email" name="email" required />

      <p class="mt-5">
        Retrouvez ces informations dans le mail de confirmation envoyé par Estaly au moment de l'adhésion au contrat.
      </p>

      <div class="mt-5 flex w-full items-center justify-center h-24">
        <NextButton @click="nextStep" :disabled="!requiredFieldsFilled" :saving="saving" />
      </div>
    </template>
  </div>
</template>

<script>
import {
  ClaimDeclarationFormStep as Step,
  ClaimDeclarationFormNextButton as NextButton,
  FormField,
  Selector,
  Alert,
  isPresent,
} from "@estaly/ui";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  extends: Step,
  components: {
    NextButton,
    FormField,
    Selector,
    Alert,
  },
  data() {
    return {
      email: null,
      planSaleFriendlyId: null,
      requiredFieldsFilled: false,
    };
  },
  computed: {
    ...mapState("auth", ["currentUser"]),
    ...mapState("customer", ["plans"]),
    ...mapState("claimDeclarations", ["declarationId"]),
    ...mapGetters("planSales", ["isActive"]),
    planSaleOptions() {
      return (this.plans ?? [])
        .filter((plan) => this.isActive(plan))
        .map((plan) => ({
          label: plan.friendlyId,
          value: plan.friendlyId,
        }));
    },
  },
  mounted() {
    this.email = this.currentUser?.email || this.$route.query.email;
    this.planSaleFriendlyId = this.$route.query.plan;
    if (this.planSaleOptions.length === 1) {
      this.planSaleFriendlyId = this.planSaleOptions[0].value;
    }
  },
  watch: {
    email() {
      this.updateRequiredFieldsFilled();
    },
    planSaleFriendlyId() {
      this.updateRequiredFieldsFilled();
    },
  },
  methods: {
    isPresent,
    ...mapActions("claimDeclarations", ["create"]),
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.planSaleFriendlyId && this.email;
    },
    async nextStep() {
      this.saving = true;
      await this.create({ planSaleFriendlyId: this.planSaleFriendlyId, email: this.email });
      this.saving = false;
      if (!this.declarationId) return;

      this.$emit("next");
    },
  },
};
</script>
